'use client'

import type { AccountDetail } from '@/types/api/accounts'

import { useMemo } from 'react'

import { InvestmentIncomeBarChart } from '@/components/molecules/investment-income-bar-chart'
import { createLogger } from '@/lib/logger'

interface AccountInvestmentIncomeBarChartProps {
  account?: AccountDetail
  title?: string
  selectedSleeve?: string | null
  isLoadingAccountDetails?: boolean
}

const LOGGER = createLogger(
  'components/molecules/account-investment-income-bar-chart',
)

export function AccountInvestmentIncomeBarChart({
  account,
  isLoadingAccountDetails,
  selectedSleeve,
  title,
}: AccountInvestmentIncomeBarChartProps) {
  const cashflows = useMemo(() => {
    if (!account) {
      return {
        monthly_cashflows: [],
        yearly_cashflows: [],
      }
    }

    if (selectedSleeve && account.sleeves[selectedSleeve]) {
      if (!account.sleeves[selectedSleeve]) {
        LOGGER.error(
          `No sleeve found for account ${account.account_id} with selectedSleeve ${selectedSleeve}`,
          {
            error: new Error(
              `No sleeve found for account ${account.account_id} with selectedSleeve ${selectedSleeve}`,
            ),
          },
        )
      }
      return {
        monthly_cashflows:
          account.sleeves[selectedSleeve]?.statistics?.monthly_cashflows,
        yearly_cashflows:
          account.sleeves[selectedSleeve]?.statistics?.yearly_cashflows,
      }
    }

    return {
      monthly_cashflows: account.statistics.monthly_cashflows,
      yearly_cashflows: account.statistics.yearly_cashflows,
    }
  }, [account, selectedSleeve])

  return (
    <InvestmentIncomeBarChart
      cashflows={cashflows}
      isLoading={isLoadingAccountDetails}
      title={title}
    />
  )
}
